import { getGiftRecordReportState } from '@/modules/report/selector';
import { giftRecordSliceActions } from '@/modules/report/slice/giftRecord';
import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import { Moment } from 'moment/moment';
import {
    Dispatch,
    SetStateAction,
    useContext,
    useEffect,
    useRef,
    useState,
} from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { DialogContext } from '../..';
import { AudioPlayContext } from '../../../../contexts/AudioPlayContext';
import { WebSocketContext } from '../../../../contexts/WebSocketContext';
import { CMDPsGiftLogQuery } from '../../../../models/cmd/live';
import { DateRangePicker } from '../../../report/components/DateRangePicker';
import { GiftRecordDetailsReport } from './GiftRecordDetailsReport';

type Props = {
    setIsOpen: Dispatch<SetStateAction<boolean>>;
};

export const GiftRecord = (props: Props) => {
    const { setIsOpen } = props;

    const dispatch = useDispatch();
    const [start, setStart] = useState<Moment>();
    const [end, setEnd] = useState<Moment>();
    const [expanded, setExpanded] = useState<boolean>(false);
    const [isRequest, setIsRequest] = useState<boolean>(false);
    const { request } = useSelector(getGiftRecordReportState);
    const timerRef = useRef<NodeJS.Timeout>();

    const { playButtonAudio } = useContext(AudioPlayContext);
    const { sendCommand } = useContext(WebSocketContext);
    const { setExtraCloseHandler } = useContext(DialogContext);

    const handleSubmit = async (_startDate: Moment, _endDate: Moment) => {
        if (_startDate && _endDate) {
            dispatch(giftRecordSliceActions.reset());
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            setIsRequest(true);

            const request = new CMDPsGiftLogQuery();
            request.FromDate = _startDate
                .locale('en')
                .format('YYYY-MM-DD 12:00:00');
            request.ToDate = _endDate
                .locale('en')
                .format('YYYY-MM-DD 11:59:59');
            await sendCommand(request);

            timerRef.current = setTimeout(() => {
                setIsRequest(false);
            }, 5000);
        } else {
            console.warn('app::report::betLog', 'please select date');
        }
    };
    useEffect(() => {
        console.log(isRequest);
        if (request) {
            setIsRequest(false);
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        }
    }, [request]);

    useEffect(() => {
        setExtraCloseHandler(() => () => {});
        return () => {
            batch(() => {
                dispatch(giftRecordSliceActions.reset());
            });
        };
    }, []);
    const onClose = () => {
        playButtonAudio();
        setIsOpen(false);
    };

    return (
        <>
            <DateRangePicker
                gaPrefix="btn_set-gr"
                start={start}
                end={end}
                expanded={expanded}
                setStart={setStart}
                setEnd={setEnd}
                setExpanded={setExpanded}
                showPreset={true}
                handleSubmit={handleSubmit}
                playButtonAudio={playButtonAudio}
            />
            <Grid container item direction={'column'} flexGrow={1} height={0}>
                <Box height={'100%'} display={'flex'} flexDirection={'column'}>
                    <GiftRecordDetailsReport
                        onClose={() => onClose()}
                        playButtonAudio={playButtonAudio}
                    />
                </Box>
            </Grid>
            {isRequest && <div className="record-loading"></div>}
        </>
    );
};
